import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import type { ExcludedTragetConditionType } from 'app-components/flux/transaction-rules/transactionRulesTypes';

// import ExcludeFromReports from 'assets/icons/settings-menu/ExcludeFromReports.inline.svg';
// import ExcludeFromSpendingPlan from 'assets/icons/settings-menu/ExcludeFromSpendingPlan.inline.svg';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  row: {
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    '> *': {
      lineHeight: '24px',
    },
    '>div': {
      borderRight: `1px ${theme.palette.divider} solid`,
      padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
    },
    alignContent: 'flex-start',
    alignItems: 'center',
  },
  textPaddingAfter: {
    paddingRight: theme.spacing(0.5),
  },
  highlightText: {
    color: theme.palette.info.main,
  },
  // imgRoundedBackground: {
  //   borderRadius: theme.shape.borderRadius,
  //   overflow: 'hidden',
  // },
  // imgClass: {},
}));

const ExcludedTarget = ({ excludedTarget }: { excludedTarget?: ExcludedTragetConditionType }) => {
  const { classes, cx } = useStyles();

  if (excludedTarget === undefined) {
    return <></>;
  }

  const { isExcludedFromReports: reports, isExcludedFromF2S: f2s } = excludedTarget;

  return (
    <>
      <Box className={classes.row}>
        {(reports || f2s) && (
          <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
            Exclude from
          </Typography>
        )}
        {reports && (
          <Typography className={cx(classes.textPaddingAfter, classes.highlightText)} variant='bodyMedium'>
            Reports
          </Typography>
        )}
        {reports && f2s && (
          <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
            &
          </Typography>
        )}
        {f2s && (
          <Typography className={cx(classes.textPaddingAfter, classes.highlightText)} variant='bodyMedium'>
            Free to Spend
          </Typography>
        )}
        {!reports && !f2s && <Typography variant='bodyRegular'>Include everywhere</Typography>}
        {/* <Box className={classes.imgRoundedBackground}>
            {Boolean(f2s) && (
              <ExcludeFromSpendingPlan
                className={cx(classes.imgClass, !(Boolean(f2s) && Boolean(reports)) ? 'singleIcon' : '')}
                id={`ignored-spending-plan-label`}
              />
            )}
            {Boolean(reports) && (
              <ExcludeFromReports
                className={cx(classes.imgClass, !(Boolean(f2s) && Boolean(reports)) ? 'singleIcon' : '')}
                id={`ignored-reports-label`}
              />
            )}
          </Box> */}
      </Box>
    </>
  );
};

export default ExcludedTarget;
